import { link } from "fs";
import { routes } from "../../routers/routes";
import { MenuItem } from "../../types/Layout";

export const menuList: MenuItem[] | undefined = [
  
  {
    title : "MapView",
    roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
    Items:[
      {
        id : 1,
        title : "MapView",
        type:"link",
         icon: "icon-map",
         url: routes.MapView,
      },
      {
         id : 2,
         title : "Dms",
         type:"link",
         icon: "icon-map",
         url: routes.MapViewSecond,
      }
     
    ]
  },
  {
    title: "Lists",
    roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
    Items:[
       {
          id:3,
          title:"Roms list",
          type:"link",
          icon:"icon-omsList", 
          url:routes.OmsList
       },
       {
         id:4,
         title:'Dms List',
         type:'link',
         url:routes.DmsList,
         icon:"icon-omsList", 
       }
    ]
  },
  {
    title : "Dashboard",
    roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
    Items:[
       {
          id:5,
          title:"DashBoard",
          type:'link',
          icon: "icon-dashboard",
          url :routes.DashBoard
       },
       {
        id:5,
        title:"WUA DashBoard",
        type:'link',
        icon: "icon-dashboard",
        url :routes.WuaDashboard
       }
    ]

 },


 
  {
    title: "Configuration",
    roles: ["Administrator", "Operator","Engineer","Farmer"], // visible to all,
    Items: [
     
      
      {
        id:6,
        title: "Distributary/Zone",
        type: "link",
        icon: "icon-zone",
        url: routes.DistributaryZoneList,
      },
      {
        id:7,
        title: "Scheme/Village",
        type: "link",
        icon: "icon-village",
        url: routes.SchemeVillageList,
      },
      {
        id:8,
        title: "Chak",
        type: "link",
        icon: "icon-chack",
        url: routes.ChackList,
      },
      {
        id : 9,
        title : "Chak Valve Detail",
        type : "link",
        icon : "icon-valve",
        url : routes.ChackValveDetail,
      },
     
     
      
      {
        id : 10,
        title : "Email",
        type : "link",
        icon : "icon-emails",
        url : routes.EmailList,
      },
      {
        id:11,
        title: "Chak Instrument",
        type: "link",
        icon: "icon-chackinstrument",
        url: routes.ChackInstrument,
      },
      {
        id:12,
        title: "Users",
        type: "link",
        icon: "icon-person",
        url: routes.Users,
      },
      {
        id:13,
        title:"Beneficiary",
        type:'link',
        icon:"icon-khasara",
        url:routes.BeneficiaryList
      },
      {
        id:14,
        title:"User Charges",
        type:'link',
        icon:"icon-dailyvolume",
        url:routes.WaterCharges
      },
      {
        id:15,
        title:"WUA",
        type:'link',
        icon:"icon-wualeader",
        url:routes.WuaList
      },
      {
        id:16,
        title:'Pumping Station',
        type:"link",
        icon:'icon-alarm',
        url:routes.PumpingStationList
      },
     
      
     
    ],
  },

  {
    title:'Schedule',
    roles: ["Administrator", "Operator","Engineer","Farmer"], // visible to all,
    Items:[
      {
        id:17,
        title:'Group',
        type:'link',
        icon:'icon-group',
        url:routes.GroupList
      },
        {
          id:18,
          title:"Schedule Group",
          type:"link",
          icon: "icon-schedulegroup",
          url : routes.DeviceInGroup,
        },

        {
          id:19,
          title:"Group Scheduler ",
          type:"link",
          icon: "icon-groupscheduler",
          url : routes.GroupScheduler,
        },

        {

          id:20,
          title:"Schedule Status",
          type:"link",
          icon: "icon-groupscheduler",
          url : routes.ScheduleStatus,
        }
        
    ]
  } ,
  {
    title :"Settings",
    roles: ["Administrator", "Operator","Engineer","Farmer"], // visible to all,
    Items : [
       {
         id:21,
         title:"UploadKml",
         type:"link",
         icon: "icon-kml",
         url : routes.KmlList,


       },
       {
        id:22,
        title:"Project Settings",
         type:"link",
         icon: "icon-project",
         url : routes.ProjectList,
       },
       {
         id:23,
         title:"Email Sender",
         type:"link",
         icon: "icon-emailsender",
         url : routes.EmailSender,
       },
       
       {
          id:24,
          title:"Reports",
          type:"link",
          icon:"icon-report",
          url: routes.report
       }
      
    ]
  },
   {
     title:'Pumping Station',
     roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
     Items:[
        
         {
         id:28,
          title:'Station Control',
          type:'link',
          icon:'icon-powerconsumption',
          url:routes.PumpingStationControl
         },
         {
           id:29,
           title:'SLD',
           type:'link',
           icon:'icon-powerconsumption',
           url:routes.SLD
          }
     ]
   },
   {
    title : "Pumping Station Reports",
    roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
    Items:[
      {
        id:5,
        title:"Runhours & Kwh",
        type:'link',
        icon: "icon-report",
        url :routes.CombineReport
      },
      {
       id:5,
       title:"Run Hours",
       type:'link',
       icon: "icon-report",
       url :routes.PumpRunhours
      },
       {
          id:5,
          title:"Power Consumption",
          type:'link',
          icon: "icon-report",
          url :routes.PumpKwh
       },
       {
        id:26,
        title:'RunHours & OnOff',
        type:'link',
        icon:'icon-powerconsumption',
        url:routes.PumpRun
       },
    
       {
        id:25,
        title:'Get Volume Report',
        type:'link',
        icon:'icon-dailyvolume',
        url:routes.GetReportPumpingStation
       },
       {
        id:26,
        title:'Get Status Report',
        type:'link',
        icon:'icon-powerconsumption',
        url:routes.PumpingStatusReport
       },
      
       
    ]

 },
  {
    title : "Alarms",
    roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
    Items : [
      {
        id : 30,
        title : "Active Alarms",
        type:"link",
        icon:"icon-alarm",
        url:routes.Alarms

      }
    ]
  },
  {
     title : 'Trends',
     roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
     Items :[
        {
           id:31,
           title:'Trends',
           type:'link',
           icon:'icon-trends',
           url:routes.Trends
        }
     ]
  },
  {
     title:'Summary',
     roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
     Items:[
        {
           id:32,
           title:'All Scheme Summary',
           type:'link',
           icon:'icon-report',
           url:routes.SchemeSummaryReport
        },
        {
          id:33,
          title:'Scheme Summary',
          type:'link',
          icon:'icon-report',
          url:routes.SchemeWiseSummary
         }
     ]
  },
  {
    title:'Wua Report',
    roles: ["Administrator", "Operator","Engineer","Client","Farmer"], // visible to all,
    Items:[
      {
        id:34,
        title:'WUA Month Report',
        type:'link',
        icon:'icon-report',
        url:routes.WuaMonth
     },
       {
          id:35,
          title:'All WUA Report',
          type:'link',
          icon:'icon-report',
          url:routes.WuaAllReport
       },
       {
         id:36,
         title:'WUA Wise Report',
         type:'link',
         icon:'icon-report',
         url:routes.WuaWiseReport
        },
        {
          id:37,
         title:'Water Distribution',
         type:'link',
         icon:'icon-report',
         url:routes.WuaWaterDistribution
        }
    ]
 }
  
  
  
];
